// 跳转支付页面前缀
const SCHEME_PAY = 'sailorpayment://cashier/launch'

/**
 * 业务接口返回的收银台类型（对应preview、update接口返回的tradeVersion字段值）
 */
enum CASHIER_DESK_TYPE {
  NORMAL = '0', // 标准收银台
  FRONT = '1', // 前置收银台
}

/**
 * 支付侧降级时，支付组件回调返回的收银台类型
 */
enum PAY_RESPONSE_CASHIER_TYPE {
  STANDARD = 'sailor_standard_cashier', // 标准收银台
  PRE = 'sailor_pre_cashier', // 前置收银台
}

/**
 * 前置收银台支付场景类型
 */
const FRONT_PAYMENT_ACTION_TYPE = {
  INIT_PAYMENT: 'pay_component_finished', // 支付 -> 业务 支付组件渲染完成
  UPDATE_PAY_METHOD: 'update_pay_method', // 支付 -> 业务 切换优惠信息后需要更新支付方式
  PAY_METHOD_CHANGE: 'pay_method_changed', // 支付 -> 业务 支付方式变化回调
  START_CASHIER: 'start_cashier', // 支付 -> 业务 调用前置收银台
} as const

// 业务 -> 支付 通过桥传递的数据
const PAY_COMPONENT_CALLED_TYPE = {
  UPDATE_PAY_METHOD: 'update_pay_method', // 业务 -> 支付 更新用户选择的支付方式
  SHOW_PAY_METHOD: 'guide_user_select_pay_method', // 支付 -> 业务 在用户未选择支付方式时引导用户选择
  START_CASHIER: 'start_cashier', // 业务 -> 支付 调用前置收银台
  REPORT_INFO: 'report_info', // 业务 -> 支付 上报信息
} as const

/**
 * 支付组件相关Code
 */
enum FRONT_PAYMENT_CODE {
  RENDER_SUCCESS = 10000200, // 渲染成功
  RENDER_FAILED = 10000502, // 渲染失败
  PAY_SUCCESS = 10001200, // 支付成功
  PAY_FRONT_ERROR = 10001401, // 支付前端内部错误
  PAY_BACKEND_ERROR = 10011402, // 支付后端错误
  PAY_BEHAVIOR_ERROR = 10011403, // 用户行为导致支付失败（关闭支付浮层等等）
  UPDATE_PAY_METHOD_SUCCESS = 30301200, // 更换支付方式成功
  UPDATE_PAY_METHOD_UNSELECTED = 30301401, // 用户未选择任何支付方式
  UPDATE_PAY_METHOD_UNAUTHORIZED = 30301402, // 用户授权未完成【支付宝未签约】
  UPDATE_PAY_METHOD_UNINSTALL_APP = 30301403, // 用户未安装APP【未安装微信App】
  UPDATE_PAY_METHOD_INTERNAL_ERROR = 30301404, // 支付内部错误【接口错误、通道错误】
}

/**
 * 支付方式标识
 */
enum FRONT_PAYMENT_METHOD {
  NONE = '', // 无支付方式
  BIND_CARD = 'bindcard', // 银行卡支付
  APPLE = 'applepay', // Apple支付
  ALIPAY = 'alipay', // 支付宝
  ALIPAY_HK = 'alipay_hk', // 支付宝HK
  WECHAT = 'wechatpay', // 微信支付
  PAYME = 'paymepay', // Payme
  OCTOPUS = 'octopuspay', // 八达通
}

/**
 * 支付组件默认初始化时间
 */
const INIT_PAYMENT_TIMEOUT_DURATION = {
  IOS: 800,
  ANDROID: 1000,
}

// 场景标识
enum BIZ_TRADE_SCENE_TYPE {
  Member_Order = 3, // 会员下单
  Member_Renewal = 4, // 会员续费
}

export {
  SCHEME_PAY,
  CASHIER_DESK_TYPE,
  PAY_RESPONSE_CASHIER_TYPE,
  FRONT_PAYMENT_ACTION_TYPE,
  FRONT_PAYMENT_CODE,
  FRONT_PAYMENT_METHOD,
  INIT_PAYMENT_TIMEOUT_DURATION,
  BIZ_TRADE_SCENE_TYPE,
  PAY_COMPONENT_CALLED_TYPE,
}
